export let props = ['head','tail','side','plate','plateColor','plateNumber','carDetail']
export let model = {
}
export let computed = {
  fontSize(){
    if(!this.plateNumber){
      return '14px'
    }else{
      return '30px'
    }
  },
  plateNumberText(){
    return this.plateNumber?this.plateNumber:'暂无车牌号码';
  },
  // 车牌颜色字典
  _plateColor(){
    let result = {}
    window.utils.dict.get('dict_LicenseColor_option').forEach(item => {
      let color = undefined
      try{
        color = JSON.parse(item.additional).color
      } catch(e) {
        console.log('字典分组：carNumberColour 中字典名' + item.dictName + '的附加值格式不是JSON')
      }
      result[item.dictValue] = color
    })
    return result[this.plateColor]
  },
  plateNumberColor(){
    if(!this.plateNumber){
      return '#999'
    }else{
      if(this.plateColor ===1 || this.plateColor ===3){
        return'#000000'
      }else{
        return '#fff'
      }
    }
  }
}
